import type { ResourcesConfig } from "aws-amplify";

/**
 * Amplify configuration for Chessla.
 * Values are injected via Vite env vars — set them in apps/app/.env:
 *
 *   VITE_COGNITO_USER_POOL_ID=us-east-1_abc123
 *   VITE_COGNITO_CLIENT_ID=1a2b3c4d5e6f...
 *
 * For local dev, get these values from the LocalStack init script output
 * (see infra/localstack/README.md). For production, from the Terraform
 * cognito.tf outputs.
 */
export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? "",
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? "",
    },
  },
};
